export enum LeadSystemAttributeSchemaName {
  firstName = 'FirstName',
  lastName = 'LastName',
  fullName = 'FullName',
  email = 'EmailAddress',
  leadScore = 'Score',
  owner = 'OwnerId',
  leadStage = 'ProspectStage',
  leadSource = 'Source',
  leadLocation = 'PhotoUrl',
  leadMobile = 'Phone',
  createdOn = 'CreatedOn',
  createdBy = 'CreatedById',
  modifiedOn = 'UpdatedOn',
  modifiedBy = 'UpdatedById',
  leadAge = 'LeadAge',
  ownerEmail = 'OwnerIdEmailAddress',
  lastActivityDate = 'ProspectActivityDate_Max',
  engagementScore = 'EngagementScore',
  aiActivitySummary = 'mx_Lead_Activities_AI_Summary',
}
